import BaseModelInstance from './base.model'
import { PromotionCodeRedemption as ModelDefinition } from './model-definitions'

class PromotionCodeRedemption extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default PromotionCodeRedemption
